import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { useEffect, useState } from 'react';

import axiosInstance from '../../api/axiosInstance';

import InvoicePayedRow from './InvoicePayedRow';

function InvoicesPayedTable({accounts, payedInvoices}) {

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Date d'envoi</TableCell>
                        <TableCell>Compte</TableCell>
                        <TableCell>Numéro de facture</TableCell>
                        <TableCell align="right">Montant total (€)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {payedInvoices.length != 0 && payedInvoices.map((invoice) => (
                        <InvoicePayedRow key={invoice.id} invoice={invoice} accounts={accounts} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default InvoicesPayedTable;